export default "__VITE_ASSET__CQK_HuAJ__"